import { Typography } from '@breetometer/components';
import { UploadIcon } from 'BreetAssets';

interface IPreFileSelect {
	acceptedMimeTypes: string;
}

export const FilePreFileSelect = ({ acceptedMimeTypes }: IPreFileSelect) => (
	<>
		<UploadIcon className='svg-dark svg-dark-outline svg-dark-fill' />

		<Typography
			as='p'
			variant='sub_head'
			className='breet_kyb_form_file_input_wrapper_fileName overflow color-primary-100'
		>
			<span className='breet_kyb_form_file_input_wrapper_button noline'>Click to upload</span> or drag and drop{' '}
			{acceptedMimeTypes}
		</Typography>
	</>
);
